import githubIcon from '../icons/prefilled/github.svg';
import gitlabIcon from '../icons/prefilled/gitlab.svg';

const ICONS: Record<string, string> = {
  gitlab: gitlabIcon,
  github: githubIcon,
};

const getExternalIcon = (platform: string) => ICONS[platform];

export default getExternalIcon;
